const PaymentHistoryComponent = () =>
  import("@/views/paymenthistory/PaymentHistory.vue");

export default {
  path: "payment-history",
  meta: { label: "Payment History" },
  component: {
    render(c) {
      return c("router-view");
    }
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true
      },
      component: PaymentHistoryComponent
    }
  ]
};
